import { makeStyles } from '@material-ui/core'
export const useStyles = makeStyles(theme => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    // position: 'relative',
    // flex: 1,
    // padding: theme.spacing(2),
    height: `calc(100% - 48px)`,
    overflowY: 'hidden',
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.dark_700.main : theme.palette.gray_100.main
    // backgroundImage:
    //   theme.mode === 'light'
    //     ? `url(${whatsBackground})`
    //     : `url(${whatsBackgroundDark})`,
    // backgroundPosition: 'center',
    // backgroundSize: 'cover',
    // backgroundRepeat: 'no-repeat'
  },
  gridContainer: {
    flex: 1,
    height: '100%',
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.dark_400.main : theme.palette.white_100.main
    // border: '1px solid rgba(0, 0, 0, 0.12)',
    // backgroundColor: 'inherit'
  },
  gridItem: {
    height: '100%',
  },
  gridItemTab: {
    height: '92%',
    width: '100%'
  },
  btnContainer: {
    textAlign: 'right',
    padding: 10
  },
  headerTitleBox: {
    width: '100%',
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    '& h5': {
      fontWeight: '600',
      fontSize: '1.25rem',
      color: theme.palette.blue_300.main
    },
    '& .MuiTypography-gutterBottom': {
      marginBottom: 0
    }
  },
  headerTutorial: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '& span': {
      fontWeight: '600',
      fontSize: '1rem'
    },
    '& button': {
      color: theme.palette.blue_100.main,
      '& span': {
        display: 'flex',
        gap: '4px'
      }
    },
    '& button:hover': {
      color: theme.palette.blue_300.main,
      backgroundColor: 'transparent'
    }
  },
  headerDescription: {
    '& span': {
      color: theme.palette.type === 'dark' ? theme.palette.dark_50.main : theme.palette.gray_400.main
    }
  },
  buttonNewChat: {
    backgroundColor: theme.palette.green_200.main,
    color: '#fff',
    borderRadius: 8,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.palette.blue_300.main,
      boxShadow: 'none'
    }
  }
}))
